import { render, staticRenderFns } from "./form-kickoff.vue?vue&type=template&id=209b62d1"
import script from "./form-kickoff.vue?vue&type=script&lang=js"
export * from "./form-kickoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports